import KitConfigurationVersionPersTypes from 'store/actionTypes/kitConfigurationVersionPers'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {}
}

const kitConfigurationVersionPers = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case KitConfigurationVersionPersTypes.GET_LIST_KIT_CONFIGURATION_VERSION_PERS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case KitConfigurationVersionPersTypes.GET_DETAIL_KIT_CONFIGURATION_VERSION_PERS_SUCCESS:
      return {
        ...state,
        current: payload?.kitConfigurationVersion
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default kitConfigurationVersionPers
